import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { contentSchema } from "../../../schemas/contentSchema";
import { FileText, Link as LinkIcon } from "lucide-react";
import RichTextEditor from "../../../components/CustomCkeditor/CustomCKEditor";
import LoadingButton from "../../../components/LoadingButton";

export default function ContentForm({
  mode,
  defaultValues = {},
  onSubmit,
  onCancel,
  submissionLoading = false,
  CMSData = {},
}) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
  } = useForm({
    resolver: yupResolver(contentSchema),
    defaultValues: {
      title: defaultValues.title || "",
      description: defaultValues.description || "",
      mode,
    },
  });
  const description = watch("description");

  // Build options for react-select from contentsList

  // Determine selected options from defaultValues.contentIds

  return (
    <form onSubmit={(e)=>{
      handleSubmit(onSubmit)(e)
      e.preventDefault();
    }} className="space-y-6">
      {/* Page Title */}
      <div>
        <label className="block text-sm font-medium mb-1">Page Title</label>
        <div className="relative">
          <FileText className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 mr-5" />
          <input
            value={CMSData?.title || ""}
            readOnly
            placeholder="Enter page title"
            className="pl-10 pr-3 py-2 border rounded w-full"
          />
        </div>
        {errors.title && (
          <p className="text-red-500 text-xs mt-1">{errors.title.message}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium mb-1">Content Title</label>
        <div className="relative">
          <FileText className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 mr-5" />
          <input
            {...register("title")}
            readOnly={mode === "view"}
            placeholder="Enter content title"
            className="pl-10 pr-3 py-2 border rounded w-full"
          />
        </div>
        {errors.title && (
          <p className="text-red-500 text-xs mt-1">{errors.title.message}</p>
        )}
      </div>

      {/* Multi-Select Contents */}
      <div>
        <label className="block text-sm font-medium mb-1">Contents</label>
        <div className="relative">
          <RichTextEditor
            value={description}
            onChange={(data) => setValue("description", data)}
            customConfig={{ isReadOnly: mode === "view" }}
          />
        </div>
        {errors.path && (
          <p className="text-red-500 text-xs mt-1">{errors.path.message}</p>
        )}
      </div>

      {/* Action Buttons */}
      <div className="flex justify-end space-x-3 pt-4 border-t">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 border rounded text-gray-700"
        >
          {mode === "view" ? "Close" : "Cancel"}
        </button>
        {mode !== "view" && (
          <button
            type="submit"
            disabled={submissionLoading}
            className="px-4 py-2 bg-primary text-white rounded flex items-center justify-center gap-2"
          >
            {submissionLoading ? (
              <LoadingButton />
            ) : (
              <>{mode === "edit" ? "Save Changes" : "Create Content"}</>
            )}
          </button>
        )}
      </div>
    </form>
  );
}
